import { ethereum } from 'thirdweb/chains'
import { NetworkEnvironment } from '../types'
import environment from '../environment'

const subgraphApiKey = environment.subgraphApiKey
const subgraphDeploymentId = 'QmSCYeXRt4bKN4xV2H2Ww8nZif4q2cW3GRVon6We6QNYYy'

export const ethereumEnvironment: NetworkEnvironment = {
  subgraphUrls: {
    main: `https://gateway.thegraph.com/api/${subgraphApiKey}/subgraphs/id/HkutM7yG99VMd9rae3nypS5rHYGsqSWgbpLBZH8jXLsn`,
    sx1155: `https://gateway-arbitrum.network.thegraph.com/api/${subgraphApiKey}/subgraphs/id/8sYwvmR23zqSVuL6Foxc79oWStTjweqX6kkeg6eBxgKg`,
    swarm: `https://gateway-arbitrum.network.thegraph.com/api/${subgraphApiKey}/deployments/id/${subgraphDeploymentId}`,
  },
  contracts: {
    dotcContractAddress: '0x0a103eE32F4209926D8ba7e528AFf8a831Ed3daE',
    dotcEscrowContractAddress: '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89',
    smtDistributorAddress: '0x6b0f858Ac88f13BB26081a8E86D3DD723c8031AC',
  },
  tokens: {
    smt: '0xB17548c7B510427baAc4e267BEa62e800b247173',
    xGold: '0x7F94388A552580712C4ec724f470c6E4a74B5244',
    goldOz: '0x6ce43f19a23ba474449d6231446d752ab3db3f6d',
    goldKg: '0xba4ac703ca1825a5d32e356c92e9a770feed35b9',
  },
}

export const ethereumChainConfig = ethereum
